import { createSlice } from "@reduxjs/toolkit";
import {
  getProcurement,
  getProcurementByLimitApproval,
  getProcurementByPaymentApproval,
  getProcurementByPayment,
  getProcurementByPaymentReconcile,
  getProcurementByPaymentStatus,
  updateProcurementByLimitApproval,
  updateProcurementByPayment,
  updateProcurementByPaymentReconcile,
  updateProcurementByPaymentApproval,
  getProcurementReport,
  getProcurementByLimitApprovalReport,
  getProcurementByPaymentApprovalReport,
  getProcurementByPaymentReport,
  getProcurementByPaymentReconcileReport,
  getProcurementByPaymentStatusReport,
  getProcurementByPaymentSuccessReport,
  getProcurementByPaymentEcocash,
  updateProcurementByPaymentEcocash,
  getProcurementByPaymentReconcileEcocash,
  updateProcurementByPaymentReconcileEcocash,
  getProcurementByPaymentCash,
  updateProcurementByPaymentCash,
  getProcurementByPaymentSummaryReport,
} from "./actions/procurement.actions";

const initialState = {
  loading: false,
  procurementUsers: null,
  procurementActivity: null,

  procurement: null,
  total: 0,
  procFilters: {},
  procPageState: { page: 1, pageSize: 50 },

  procurementByLimitApproval: null,
  totalByLimitApproval: 0,
  procLimitApprovalFilters: {},
  procLimitApprovalPageState: { page: 1, pageSize: 50 },

  procurementByPaymentApproval: null,
  totalByPaymentApproval: 0,
  procPayApprovalFilters: {},
  procPayApprovalPageState: { page: 1, pageSize: 50 },

  procurementByPaymentCbzFbc: null,
  totalByPaymentCbzFbc: 0,
  procPaymentFiltersCbzFbc: {},
  procPaymentPageStateCbzFbc: { page: 1, pageSize: 50 },

  procurementByPaymentEcocash: null,
  totalByPaymentEcocash: 0,
  procPaymentFiltersEcocash: {},
  procPaymentPageStateEcocash: { page: 1, pageSize: 50 },

  procurementByPaymentCash: null,
  totalByPaymentCash: 0,
  procPaymentFiltersCash: {},
  procPaymentPageStateCash: { page: 1, pageSize: 50 },

  procurementByPaymentStatus: null,
  totalByPaymentStatus: 0,
  procPayStatusFilters: {},
  procPayStatusPageState: { page: 1, pageSize: 50 },

  procurementByPaymentReconcileCbzFbc: null,
  totalByReconcileCbzFbc: 0,
  procPayReconcileFiltersCbzFbc: {},
  procPayReconcilePageStateCbzFbc: { page: 1, pageSize: 50 },

  procurementByPaymentReconcileEcocash: null,
  totalByReconcileEcocash: 0,
  procPayReconcileFiltersEcocash: {},
  procPayReconcilePageStateEcocash: { page: 1, pageSize: 50 },

  procurementReport: null,
  totalProcurementReport: 0,
  procReportFilters: {},
  procReportPageState: { page: 1, pageSize: 50 },

  procurementByLimitApprovalReport: null,
  totalByLimitApprovalReport: 0,
  procLimitApprovalReportFilters: {},
  procLimitApprovalReportPageState: { page: 1, pageSize: 50 },

  procurementByPaymentApprovalReport: null,
  totalByPaymentApprovalReport: 0,
  procPayApprovalReportFilters: {},
  procPayApprovalReportPageState: { page: 1, pageSize: 50 },

  procurementByPaymentReport: null,
  totalByPaymentReport: 0,
  procPayReportFilters: {},
  procPayReportPageState: { page: 1, pageSize: 50 },

  procurementByPaymentStatusReport: null,
  totalByPaymentStatusReport: 0,
  procPayStatusReportFilters: {},
  procPayStatusReportPageState: { page: 1, pageSize: 50 },

  procurementByPaymentReconcileReport: null,
  totalByPaymentReconcileReport: 0,
  procPayReconcileReportFilters: {},
  procPayReconcileReportPageState: { page: 1, pageSize: 50 },

  procurementByPaymentSuccessReport: null,
  totalByPaymentSuccessReport: 0,
  procPaySuccessReportFilters: {},
  procPaySuccessReportPageState: { page: 1, pageSize: 50 },

  procurementByPaymentSummaryReport: null,
  totalByPaymentSummaryReport: 0,
  procPaySummaryReportFilters: {},
  procPaySummaryReportPageState: { page: 1, pageSize: 50 },

};

export const procurementSlice = createSlice({
  name: "procurement",
  initialState,
  reducers: {
    setProcurementActivity: (state, action) => {
      state.procurementActivity = action.payload;
    },
    setProcurementActivityNull: (state) => {
      state.procurementActivity = null;
    },

    setProcFilters: (state, action) => {
      const { payload } = action;
      state.procFilters = payload || {};
    },
    resetProcFilters: (state) => {
      state.procFilters = {};
    },
    setProcPage: (state, action) => {
      const { page, pageSize } = action.payload;
      if (page) {
        state.procPageState = { ...state.procPageState, page };
      }
      if (pageSize) {
        state.procPageState = { ...state.procPageState, pageSize };
      }
    },

    setProcLimitApprovalFilters: (state, action) => {
      const { payload } = action;
      state.procLimitApprovalFilters = payload || {};
    },
    resetProcLimitApprovalFilters: (state) => {
      state.procLimitApprovalFilters = {};
    },
    setProcLimitApprovalPage: (state, action) => {
      const { page, pageSize } = action.payload;
      if (page) {
        state.procLimitApprovalPageState = {
          ...state.procLimitApprovalPageState,
          page,
        };
      }
      if (pageSize) {
        state.procLimitApprovalPageState = {
          ...state.procLimitApprovalPageState,
          pageSize,
        };
      }
    },

    setProcPayApprovalFilters: (state, action) => {
      const { payload } = action;
      state.procPayApprovalFilters = payload || {};
    },
    resetProcPayApprovalFilters: (state) => {
      state.procPayApprovalFilters = {};
    },
    setProcPayApprovalPage: (state, action) => {
      const { page, pageSize } = action.payload;
      if (page) {
        state.procPayApprovalPageState = {
          ...state.procPayApprovalPageState,
          page,
        };
      }
      if (pageSize) {
        state.procPayApprovalPageState = {
          ...state.procPayApprovalPageState,
          pageSize,
        };
      }
    },

    setProcPaymentFilters: (state, action) => {
      const { payload } = action;
      state.procPaymentFiltersCbzFbc = payload || {};
    },
    resetProcPaymentFilters: (state) => {
      state.procPaymentFiltersCbzFbc = {};
    },
    setProcPaymentPage: (state, action) => {
      const { page, pageSize } = action.payload;
      if (page) {
        state.procPaymentPageStateCbzFbc = {
          ...state.procPaymentPageStateCbzFbc,
          page,
        };
      }
      if (pageSize) {
        state.procPaymentPageStateCbzFbc = {
          ...state.procPaymentPageStateCbzFbc,
          pageSize,
        };
      }
    },

    setProcPaymentFilters: (state, action) => {
      const { payload } = action;
      state.procPaymentFiltersEcocash = payload || {};
    },
    resetProcPaymentFilters: (state) => {
      state.procPaymentFiltersEcocash = {};
    },
    setProcPaymentPage: (state, action) => {
      const { page, pageSize } = action.payload;
      if (page) {
        state.procPaymentPageStateEcocash = {
          ...state.procPaymentPageStateEcocash,
          page,
        };
      }
      if (pageSize) {
        state.procPaymentPageStateEcocash = {
          ...state.procPaymentPageStateEcocash,
          pageSize,
        };
      }
    },

    setProcPaymentFilters: (state, action) => {
      const { payload } = action;
      state.procPaymentFiltersCash = payload || {};
    },
    resetProcPaymentFilters: (state) => {
      state.procPaymentFiltersCash = {};
    },
    setProcPaymentPage: (state, action) => {
      const { page, pageSize } = action.payload;
      if (page) {
        state.procPaymentPageStateCash = {
          ...state.procPaymentPageStateCash,
          page,
        };
      }
      if (pageSize) {
        state.procPaymentPageStateCash = {
          ...state.procPaymentPageStateCash,
          pageSize,
        };
      }
    },

    setProcPayStatusFilters: (state, action) => {
      const { payload } = action;
      state.procPayStatusFilters = payload || {};
    },
    resetProcPayStatusFilters: (state) => {
      state.procPayStatusFilters = {};
    },
    setProcPayStatusPage: (state, action) => {
      const { page, pageSize } = action.payload;
      if (page) {
        state.procPayStatusPageState = {
          ...state.procPayStatusPageState,
          page,
        };
      }
      if (pageSize) {
        state.procPayStatusPageState = {
          ...state.procPayStatusPageState,
          pageSize,
        };
      }
    },

    setProcPayReconcileFilters: (state, action) => {
      const { payload } = action;
      state.procPayReconcileFiltersCbzFbc = payload || {};
    },
    resetProcPayReconcileFilters: (state) => {
      state.procPayReconcileFiltersCbzFbc = {};
    },
    setProcPayReconcilePage: (state, action) => {
      const { page, pageSize } = action.payload;
      if (page) {
        state.procPayReconcilePageStateCbzFbc = {
          ...state.procPayReconcilePageStateCbzFbc,
          page,
        };
      }
      if (pageSize) {
        state.procPayReconcilePageStateCbzFbc = {
          ...state.procPayReconcilePageStateCbzFbc,
          pageSize,
        };
      }
    },

    setProcPayReconcileFilters: (state, action) => {
      const { payload } = action;
      state.procPayReconcileFiltersEcocash = payload || {};
    },
    resetProcPayReconcileFilters: (state) => {
      state.procPayReconcileFiltersEcocash = {};
    },
    setProcPayReconcilePage: (state, action) => {
      const { page, pageSize } = action.payload;
      if (page) {
        state.procPayReconcilePageStateEcocash = {
          ...state.procPayReconcilePageStateEcocash,
          page,
        };
      }
      if (pageSize) {
        state.procPayReconcilePageStateEcocash = {
          ...state.procPayReconcilePageStateEcocash,
          pageSize,
        };
      }
    },

    setProcReportFilters: (state, action) => {
      const { payload } = action;
      state.procReportFilters = payload || {};
    },
    resetProcReportFilters: (state) => {
      state.procReportFilters = {};
    },
    setProcReportPage: (state, action) => {
      const { page, pageSize } = action.payload;
      if (page) {
        state.procReportPageState = {
          ...state.procReportPageState,
          page,
        };
      }
      if (pageSize) {
        state.procReportPageState = {
          ...state.procReportPageState,
          pageSize,
        };
      }
    },

    setProcLimitApprovalReportFilters: (state, action) => {
      const { payload } = action;
      state.procLimitApprovalReportFilters = payload || {};
    },
    resetProcLimitApprovalReportFilters: (state) => {
      state.procLimitApprovalReportFilters = {};
    },
    setProcLimitApprovalReportPage: (state, action) => {
      const { page, pageSize } = action.payload;
      if (page) {
        state.procLimitApprovalReportPageState = {
          ...state.procLimitApprovalReportPageState,
          page,
        };
      }
      if (pageSize) {
        state.procLimitApprovalReportPageState = {
          ...state.procLimitApprovalReportPageState,
          pageSize,
        };
      }
    },

    setProcPayApprovalReportFilters: (state, action) => {
      const { payload } = action;
      state.procPayApprovalReportFilters = payload || {};
    },
    resetProcPayApprovalReportFilters: (state) => {
      state.procPayApprovalReportFilters = {};
    },
    setProcPayApprovalReportPage: (state, action) => {
      const { page, pageSize } = action.payload;
      if (page) {
        state.procPayApprovalReportPageState = {
          ...state.procPayApprovalReportPageState,
          page,
        };
      }
      if (pageSize) {
        state.procPayApprovalReportPageState = {
          ...state.procPayApprovalReportPageState,
          pageSize,
        };
      }
    },

    setProcPayReportFilters: (state, action) => {
      const { payload } = action;
      state.procPayReportFilters = payload || {};
    },
    resetProcPayReportFilters: (state) => {
      state.procPayReportFilters = {};
    },
    setProcPayReportPage: (state, action) => {
      const { page, pageSize } = action.payload;
      if (page) {
        state.procPayReportPageState = {
          ...state.procPayReportPageState,
          page,
        };
      }
      if (pageSize) {
        state.procPayReportPageState = {
          ...state.procPayReportPageState,
          pageSize,
        };
      }
    },

    setProcPayStatusReportFilters: (state, action) => {
      const { payload } = action;
      state.procPayStatusReportFilters = payload || {};
    },
    resetProcPayStatusReportFilters: (state) => {
      state.procPayStatusReportFilters = {};
    },
    setProcPayStatusReportPage: (state, action) => {
      const { page, pageSize } = action.payload;
      if (page) {
        state.procPayStatusReportPageState = {
          ...state.procPayStatusReportPageState,
          page,
        };
      }
      if (pageSize) {
        state.procPayStatusReportPageState = {
          ...state.procPayStatusReportPageState,
          pageSize,
        };
      }
    },

    setProcPayReconcileReportFilters: (state, action) => {
      const { payload } = action;
      state.procPayReconcileReportFilters = payload || {};
    },
    resetProcPayReconcileReportFilters: (state) => {
      state.procPayReconcileReportFilters = {};
    },
    setProcPayReconcileReportPage: (state, action) => {
      const { page, pageSize } = action.payload;
      if (page) {
        state.procPayReconcileReportPageState = {
          ...state.procPayReconcileReportPageState,
          page,
        };
      }
      if (pageSize) {
        state.procPayReconcileReportPageState = {
          ...state.procPayReconcileReportPageState,
          pageSize,
        };
      }
    },
    setProcPaySuccessReportFilters: (state, action) => {
      const { payload } = action;
      state.procPaySuccessReportFilters = payload || {};
    },
    resetProcPaySuccessReportFilters: (state) => {
      state.procPaySuccessReportFilters = {};
    },
    setProcPaySuccessReportPage: (state, action) => {
      const { page, pageSize } = action.payload;
      if (page) {
        state.procPaySuccessReportPageState = {
          ...state.procPaySuccessReportPageState,
          page,
        };
      }
      if (pageSize) {
        state.procPaySuccessReportPageState = {
          ...state.procPaySuccessReportPageState,
          pageSize,
        };
      }
    },

    setProcPaySummaryReportFilters: (state, action) => {
      const { payload } = action;
      state.procPaySuccessReportFilters = payload || {};
    },
    resetProcPaySummaryReportFilters: (state) => {
      state.procPaySuccessReportFilters = {};
    },
    setProcPaySummaryReportPage: (state, action) => {
      const { page, pageSize } = action.payload;
      if (page) {
        state.procPaySummaryReportPageState = {
          ...state.procPaySummaryReportPageState,
          page,
        };
      }
      if (pageSize) {
        state.procPaySummaryReportPageState = {
          ...state.procPaySummaryReportPageState,
          pageSize,
        };
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProcurement.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProcurement.fulfilled, (state, action) => {
        const { data, count, user } = action.payload;
        state.loading = false;
        state.procurementUsers = user;
        state.procurement = data;

        state.total = count;
      })
      .addCase(getProcurement.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(getProcurementByLimitApproval.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProcurementByLimitApproval.fulfilled, (state, action) => {
        const { data, count, user } = action.payload;
        state.loading = false;
        state.procurementByLimitApproval = data;
        state.procurementUsers = user;
        state.totalByLimitApproval = count;
      })
      .addCase(getProcurementByLimitApproval.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(updateProcurementByLimitApproval.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateProcurementByLimitApproval.fulfilled, (state, action) => {
        const { data, count, user } = action.payload;
        state.loading = false;
        state.procurementByLimitApproval = data;
        state.procurementUsers = user;
        state.totalByLimitApproval = count;
      })
      .addCase(updateProcurementByLimitApproval.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(getProcurementByPaymentApproval.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProcurementByPaymentApproval.fulfilled, (state, action) => {
        const { data, count, user } = action.payload;
        state.loading = false;
        state.procurementByPaymentApproval = data;
        state.procurementUsers = user;
        state.totalByPaymentApproval = count;
      })
      .addCase(getProcurementByPaymentApproval.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(updateProcurementByPaymentApproval.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        updateProcurementByPaymentApproval.fulfilled,
        (state, action) => {
          const { data, count, user } = action.payload;
          state.loading = false;
          state.procurementByPaymentApproval = data;
          state.procurementUsers = user;
          state.totalByPaymentApproval = count;
        }
      )
      .addCase(updateProcurementByPaymentApproval.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(getProcurementByPayment.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProcurementByPayment.fulfilled, (state, action) => {
        const { data, count, user } = action.payload;
        state.loading = false;
        state.procurementByPaymentCbzFbc = data;
        state.procurementUsers = user;
        state.totalByPaymentCbzFbc = count;
      })
      .addCase(getProcurementByPayment.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(updateProcurementByPayment.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateProcurementByPayment.fulfilled, (state, action) => {
        const { data, count, user } = action.payload;
        state.loading = false;
        state.procurementByPaymentCbzFbc = data;
        state.procurementUsers = user;
        state.totalByPaymentCbzFbc = count;
      })
      .addCase(updateProcurementByPayment.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(updateProcurementByPaymentEcocash.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateProcurementByPaymentEcocash.fulfilled, (state, action) => {
        const { data, count, user } = action.payload;
        state.loading = false;
        state.procurementByPaymentEcocash = data;
        state.procurementUsers = user;
        state.totalByPaymentEcocash = count;
      })
      .addCase(updateProcurementByPaymentEcocash.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(getProcurementByPaymentEcocash.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProcurementByPaymentEcocash.fulfilled, (state, action) => {
        const { data, count, user } = action.payload;
        state.loading = false;
        state.procurementByPaymentEcocash = data;
        state.procurementUsers = user;
        state.totalByPaymentEcocash = count;
      })
      .addCase(getProcurementByPaymentEcocash.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(updateProcurementByPaymentCash.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateProcurementByPaymentCash.fulfilled, (state, action) => {
        const { data, count, user } = action.payload;
        state.loading = false;
        state.procurementByPaymentCash = data;
        state.procurementUsers = user;
        state.totalByPaymentCash = count;
      })
      .addCase(updateProcurementByPaymentCash.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(getProcurementByPaymentCash.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProcurementByPaymentCash.fulfilled, (state, action) => {
        const { data, count, user } = action.payload;
        state.loading = false;
        state.procurementByPaymentCash = data;
        state.procurementUsers = user;
        state.totalByPaymentCash = count;
      })
      .addCase(getProcurementByPaymentCash.rejected, (state) => {
        state.loading = false;
      });

      builder
      .addCase(getProcurementByPaymentStatus.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProcurementByPaymentStatus.fulfilled, (state, action) => {
        const { data, count, user } = action.payload;
        state.loading = false;
        state.procurementByPaymentStatus = data;
        state.procurementUsers = user;
        state.totalByPaymentStatus = count;
      })
      .addCase(getProcurementByPaymentStatus.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(getProcurementByPaymentReconcile.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProcurementByPaymentReconcile.fulfilled, (state, action) => {
        const { data, count, user } = action.payload;
        state.loading = false;
        state.procurementByPaymentReconcileCbzFbc = data;
        state.procurementUsers = user;
        state.totalByReconcileCbzFbc = count;
      })
      .addCase(getProcurementByPaymentReconcile.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(getProcurementByPaymentReconcileEcocash.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        getProcurementByPaymentReconcileEcocash.fulfilled,
        (state, action) => {
          const { data, count, user } = action.payload;
          state.loading = false;
          state.procurementByPaymentReconcileEcocash = data;
          state.procurementUsers = user;
          state.totalByReconcileEcocash = count;
        }
      )
      .addCase(getProcurementByPaymentReconcileEcocash.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(updateProcurementByPaymentReconcile.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        updateProcurementByPaymentReconcile.fulfilled,
        (state, action) => {
          const { data, count, user } = action.payload;
          state.loading = false;
          state.procurementByPaymentReconcileCbzFbc = data;
          state.procurementUsers = user;
          state.totalByReconcileCbzFbc = count;
        }
      )
      .addCase(updateProcurementByPaymentReconcile.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(updateProcurementByPaymentReconcileEcocash.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        updateProcurementByPaymentReconcileEcocash.fulfilled,
        (state, action) => {
          const { data, count, user } = action.payload;
          state.loading = false;
          state.procurementByPaymentReconcileEcocash = data;
          state.procurementUsers = user;
          state.totalByReconcileEcocash = count;
        }
      )
      .addCase(updateProcurementByPaymentReconcileEcocash.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(getProcurementReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProcurementReport.fulfilled, (state, action) => {
        const { data, count, user } = action.payload;
        state.loading = false;
        state.procurementUsers = user;
        state.procurementReport = data;

        state.totalProcurementReport = count;
      })
      .addCase(getProcurementReport.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(getProcurementByLimitApprovalReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        getProcurementByLimitApprovalReport.fulfilled,
        (state, action) => {
          const { data, count, user } = action.payload;
          state.loading = false;
          state.procurementByLimitApprovalReport = data;
          state.procurementUsers = user;
          state.totalByLimitApprovalReport = count;
        }
      )
      .addCase(getProcurementByLimitApprovalReport.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(getProcurementByPaymentApprovalReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        getProcurementByPaymentApprovalReport.fulfilled,
        (state, action) => {
          const { data, count, user } = action.payload;
          state.loading = false;
          state.procurementByPaymentApprovalReport = data;
          state.procurementUsers = user;
          state.totalByPaymentApprovalReport = count;
        }
      )
      .addCase(getProcurementByPaymentApprovalReport.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(getProcurementByPaymentReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProcurementByPaymentReport.fulfilled, (state, action) => {
        const { data, count, user } = action.payload;
        state.loading = false;
        state.procurementByPaymentReport = data;
        state.procurementUsers = user;
        state.totalByPaymentReport = count;
      })
      .addCase(getProcurementByPaymentReport.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(getProcurementByPaymentStatusReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        getProcurementByPaymentStatusReport.fulfilled,
        (state, action) => {
          const { data, count, user } = action.payload;
          state.loading = false;
          state.procurementByPaymentStatusReport = data;
          state.procurementUsers = user;
          state.totalByPaymentStatusReport = count;
        }
      )
      .addCase(getProcurementByPaymentStatusReport.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(getProcurementByPaymentReconcileReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        getProcurementByPaymentReconcileReport.fulfilled,
        (state, action) => {
          const { data, count, user } = action.payload;
          state.loading = false;
          state.procurementByPaymentReconcileReport = data;
          state.procurementUsers = user;
          state.totalByPaymentReconcileReport = count;
        }
      )
      .addCase(getProcurementByPaymentReconcileReport.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(getProcurementByPaymentSuccessReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        getProcurementByPaymentSuccessReport.fulfilled,
        (state, action) => {
          const { data, count, user } = action.payload;
          state.loading = false;
          state.procurementByPaymentSuccessReport = data;
          state.procurementUsers = user;
          state.totalByPaymentSuccessReport = count;
        }
      )
      .addCase(getProcurementByPaymentSuccessReport.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(getProcurementByPaymentSummaryReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        getProcurementByPaymentSummaryReport.fulfilled,
        (state, action) => {
          const { data, count, user } = action.payload;
          state.loading = false;
          state.procurementByPaymentSummaryReport = data;
          state.procurementUsers = user;
          state.totalByPaymentSummaryReport = count;
        }
      )
      .addCase(getProcurementByPaymentSummaryReport.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const {
  setProcurementActivity,
  setProcurementActivityNull,
  setProcFilters,
  resetProcFilters,
  setProcLimitApprovalFilters,
  resetProcLimitApprovalFilters,
  setProcPayApprovalFilters,
  resetProcPayApprovalFilters,
  setProcPaymentFilters,
  resetProcPaymentFilters,
  setProcPayStatusFilters,
  resetProcPayStatusFilters,
  setProcPayReconcileFilters,
  resetProcPayReconcileFilters,
  setProcReportFilters,
  resetProcReportFilters,
  setProcLimitApprovalReportFilters,
  resetProcLimitApprovalReportFilters,
  setProcPayApprovalReportFilters,
  resetProcPayApprovalReportFilters,
  setProcPayReportFilters,
  resetProcPayReportFilters,
  setProcPayStatusReportFilters,
  resetProcPayStatusReportFilters,
  setProcPayReconcileReportFilters,
  resetProcPayReconcileReportFilters,
  setProcPaySuccessReportFilters,
  resetProcPaySuccessReportFilters,
  setProcPaySummaryReportFilters,
  resetProcPaySummaryReportFilters,

  setProcPage,
  setProcLimitApprovalPage,
  setProcLimitApprovalReportPage,
  setProcPaymentPage,
  setProcPayApprovalPage,
  setProcPayApprovalReportPage,
  setProcPayReportPage,
  setProcPayStatusPage,
  setProcPayStatusReportPage,
  setProcPayReconcilePage,
  setProcPayReconcileReportPage,
  setProcPaySuccessReportPage,
  setProcPaySummaryReportPage,
  setProcReportPage,
} = procurementSlice.actions;

export default procurementSlice.reducer;
